import React from "react";
import { fileIcons } from "../../Icons";

const DragOverlay = ({currentFolder = {}}) => {
    const {name} = currentFolder
    const FolderIcon = fileIcons?.['folder']
  return (
      <div
        className="bg-[#F5F9FF] fixed bottom-4 left-1/2 -translate-x-1/2 flex flex-col gap-2 items-center justify-center z-[100] pointer-events-none rounded-md w-fit p-4"
        style={
          {
            //   border: `2px dashed ${sendButtonColor}`,
          }
        }
      >
        <svg
          width="33"
          height="25"
          viewBox="0 0 30 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.3333 21.3333H7.33333C5.31111 21.3333 3.58333 20.6333 2.15 19.2333C0.716667 17.8333 0 16.1222 0 14.1C0 12.3667 0.522222 10.8222 1.56667 9.46667C2.61111 8.11111 3.97778 7.24444 5.66667 6.86667C6.22222 4.82222 7.33333 3.16667 9 1.9C10.6667 0.633333 12.5556 0 14.6667 0C17.2667 0 19.4722 0.905556 21.2833 2.71667C23.0944 4.52778 24 6.73333 24 9.33333C25.5333 9.51111 26.8056 10.1722 27.8167 11.3167C28.8278 12.4611 29.3333 13.8 29.3333 15.3333C29.3333 17 28.75 18.4167 27.5833 19.5833C26.4167 20.75 25 21.3333 23.3333 21.3333H16V11.8L18.1333 13.8667L20 12L14.6667 6.66667L9.33333 12L11.2 13.8667L13.3333 11.8V21.3333Z"
            fill="#0068FF"
          />
        </svg>

        <p
          className="text-base font-medium text-center text-[#232323] text-[0.9rem]"
          //   style={{ color: sendButtonColor }}
        >
          Drop files to upload them to
        </p>
        <p className="text-xs text-gray-500 mt-1 flex items-center gap-2">
          <span> <FolderIcon /> </span>
          <span className="text-[#232323] font-medium text-[1rem]"> {name} </span>
        </p>
      </div>
  );
};

export default DragOverlay;
